import { render, staticRenderFns } from "./personBindRole.vue?vue&type=template&id=7beeaa0a"
import script from "./personBindRole.vue?vue&type=script&lang=js"
export * from "./personBindRole.vue?vue&type=script&lang=js"
import style0 from "./personBindRole.vue?vue&type=style&index=0&id=7beeaa0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports